export const setIcon = (text) => {
  if (text.includes("adults")) {
    return "icon-Users";
  }
  if (text.includes("utomatic")) {
    return "icon-Container";
  }
  if (text.includes("petrol")) {
    return "icon-Vertical-container";
  }
  if (text.includes("itchen")) {
    return "icon-Horizontal-container";
  }
  if (text.includes("beds")) {
    return "icon-Container-1";
  }
  if (text.includes("AC")) {
    return "icon-Vector";
  }
  if (text.includes("conditioner")) {
    return "icon-streamline_hotel-air-conditioner";
  }
  if (text.includes("CD")) {
    return "icon-icon-park-outline_cd";
  }
  if (text.includes("radio")) {
    return "icon-solar_radio-linear1";
  }
  if (text.includes("hob")) {
    return "icon-icon-park-outline_hand-painted-plate";
  }
  if (text.includes("Van")) {
    return "icon-Button-1";
  }
  if (text.includes("Fully Integrated")) {
    return "icon-Button";
  }
  if (text.includes("Alcove")) {
    return "icon-camper";
  }
  if (text.includes("Shower/WC")) {
    return "icon-Rating";
  }
  if (text.includes("TV")) {
    return "icon-Vertical-container-1";
  }
};
